import { render, staticRenderFns } from "./CatalogManagementModal.vue?vue&type=template&id=8d011b08&scoped=true"
import script from "./CatalogManagementModal.vue?vue&type=script&lang=js"
export * from "./CatalogManagementModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogManagementModal.vue?vue&type=style&index=0&id=8d011b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d011b08",
  null
  
)

export default component.exports